import useAdminAnnouncementStore from '@/domains/admin/store/adminAnnouncement.store';
import AdminAnnouncementColorEnum from '@/domains/admin/typescript/AdminAnnouncementColorEnum';
import AdminAnnouncementIconEnum from '@/domains/admin/typescript/AdminAnnouncementIconEnum';
import AdminAnnouncementPageDisplayEnum from '@/domains/admin/typescript/AdminAnnouncementPageDisplayEnum';
import IconArrowCircle from '@/domains/common/components/icons/IconArrowCircle.vue';
import { getVersion, normalizeVersion } from '@/domains/common/services/packageJsonHelper';
import { t } from '@/translations';
import { storeToRefs } from 'pinia';

export function useUpdateChecker() {
    const { announcements } = storeToRefs(useAdminAnnouncementStore());

    async function checkVersion() {
        try {
            const res = await fetch('/version.json', { cache: 'no-store' });
            if (!res.ok) {
                return;
            }
            const { version } = await res.json();

            // version.json holds the raw CI tag; normalize the "v" prefix before comparing.
            if (normalizeVersion(version) === getVersion()) {
                return;
            }
            if (hasVersionAnnoucement()) {
                return;
            }

            announcements.value.push({
                id: -1,
                text: t('update_checker.text'),
                title: t('update_checker.title'),
                unclosable: true,
                color: AdminAnnouncementColorEnum.SUCCESS,
                pictogram: AdminAnnouncementIconEnum.INFO,
                pageToDisplay: AdminAnnouncementPageDisplayEnum.GLOBAL,
                isActivated: true,
                sideEffect: {
                    label: t('update_checker.button_label'),
                    effect: () => {
                        window.location.reload();
                    },
                    icon: IconArrowCircle,
                },
                createdAt: new Date(),
                updatedAt: new Date(),
            });
        } catch {
            // Network failure or malformed version.json: skip silently, retry next navigation.
        }
    }

    function hasVersionAnnoucement() {
        return announcements.value.some((announcement) => announcement.id === -1);
    }

    return {
        checkVersion,
    };
}

export default useUpdateChecker;
